import React from 'react';
import styled from 'styled-components/macro';
import vw from 'rpf/un/vw';
import Modal from 'components/Modal';
import autobg from 'autobg.macro';
import { formatPhone, query } from 'utils';
import { getAllConfig } from 'configs';
import api from 'api';

const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: ${vw(690)};
  height: ${vw(493)};
  background-color: #ffffff;
  border-radius: ${vw(20)};
`;

const Phone = styled.div`
  margin: ${vw(116)} 0 ${vw(10)};
  font-size: ${vw(56)};
  font-weight: bold;
  color: #4460b7;
  text-align: center;
`;

const Text = styled.div`
  text-align: center;
  color: #2c2d40;
  font-size: ${vw(32)};
`;

const Tips = styled.div`
  margin: ${vw(12)} 0 ${vw(60)};
  padding: 0 ${vw(36)} 0 ${vw(67)};
  color: #d41717;
  font-size: ${vw(28)};
`;

const ConfirmBtn = styled.div`
  ${autobg('assets/img/home/btn_confirm.png')}
  margin-bottom: ${vw(24)};
`;

const ReturnBtn = styled.div`
  ${autobg('assets/img/home/btn_return.png')}
`;

const ConfirmModal = ({ values, open, onClose, onConfirm }) => {
  const handleConfirm = async () => {
    const { storeKey } = getAllConfig();
    const { unionid = '', nickname = '' } =
      JSON.parse(localStorage.getItem(storeKey)) || {};
    const form = {
      ...values,
      unionid,
      nickname,
      cnl: query.cnl
    };
    window.opfStatisticSdk.saveFormInfo(form, '1');
    const [err] = await api.postUserInfo({ ...form });
    if (err) return;
    onConfirm(values);
  };

  return (
    <Modal open={open}>
      <Wrap>
        <Phone>{formatPhone(values.mobile)}</Phone>
        <Text>请核实您的手机号码是否正确</Text>
        <Tips>*提交后不支持修改</Tips>
        <ConfirmBtn onClick={handleConfirm} />
        <ReturnBtn onClick={onClose} />
      </Wrap>
    </Modal>
  );
};

export default ConfirmModal;
